export const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  // Dates are stored as YYYY-MM-DD
  // We create a Date object for comparison against the filter date
  // Yes this is faster than dayjs :(

  const cellDate = new Date(cellValue);
  cellDate.setHours(0, 0, 0, 0);

  // Is before
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
    // Is after
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  // Is same
  return 0;
};
